export default __webpack_public_path__ + "static/media/airdockz-bpk-banner-2.827f51b6.jpg";